class DriverListModel {
    constructor({
      next = null,
      previous = null,
      count = null,
      pageCount = null,
      results = []
    } = {}) {
      this.next = next;
      this.previous = previous;
      this.count = count;
      this.pageCount = pageCount;
      this.results = results.map(result => new Results(result));
    }
  
    static fromJson(json) {
      return new DriverListModel({
        next: json.next,
        previous: json.previous,
        count: json.count ?? null,
        pageCount: json.page_count ?? null,
        results: json.content ? json.content.map(item => Results.fromJson(item)) : []
      });
    }
  
    toJson() {
      return {
        next: this.next,
        previous: this.previous,
        count: this.count,
        page_count: this.pageCount,
        results: this.results.map(result => result.toJson())
      };
    }
  }
  
  class Results {
    constructor({
      id = null,
      isDeleted = null,
      profileImageUrl = null,
      uid = null,
      name = null,
      phoneCode = null,
      phoneNumber = null,
      email = null,
      userId = null,
      licenseCode = null,
      licenseValidity = null,
      status = null,
      reportingCenter = null,
      licenseIdImageUrl = null,
      nationalIdImageUrl = null,
      createdDate = null,
      channelId = null
    } = {}) {
      this.id = id;
      this.isDeleted = isDeleted;
      this.profileImageUrl = profileImageUrl;
      this.uid = uid;
      this.name = name;
      this.phoneCode = phoneCode;
      this.phoneNumber = phoneNumber;
      this.email = email;
      this.userId = userId;
      this.licenseCode = licenseCode;
      this.licenseValidity = licenseValidity;
      this.status = status;
      this.reportingCenter = reportingCenter;
      this.licenseIdImageUrl = licenseIdImageUrl;
      this.nationalIdImageUrl = nationalIdImageUrl;
      this.createdDate = createdDate;
      this.channelId = channelId;
    }
  
    static fromJson(json) {
      return new Results({
        id: json.id ?? null,
        isDeleted: json.is_deleted ?? null,
        profileImageUrl: json.profile_image_url ?? null,
        uid: json.uid ?? null,
        name: json.name ?? null,
        phoneCode: json.phone_code ?? null,
        phoneNumber: json.phone_number ?? null,
        email: json.email ?? null,
        userId: json.user_id ?? null,
        licenseCode: json.license_code ?? null,
        licenseValidity: json.license_validity ?? null,
        status: json.status ?? null,
        reportingCenter: json.reporting_center ?? null,
        licenseIdImageUrl: json.license_id_image_url ?? null,
        nationalIdImageUrl: json.national_id_image_url ?? null,
        createdDate: json.created_date ?? null,
        channelId: json.channel_id ?? null
      });
    }
  
    toJson() {
      return {
        id: this.id,
        is_deleted: this.isDeleted,
        profile_image_url: this.profileImageUrl,
        uid: this.uid,
        name: this.name,
        phone_code: this.phoneCode,
        phone_number: this.phoneNumber,
        email: this.email,
        user_id: this.userId,
        license_code: this.licenseCode,
        license_validity: this.licenseValidity,
        status: this.status,
        reporting_center: this.reportingCenter,
        license_id_image_url: this.licenseIdImageUrl,
        national_id_image_url: this.nationalIdImageUrl,
        created_date: this.createdDate,
        channel_id: this.channelId
      };
    }
  }
export {DriverListModel}  ;